// extracted by mini-css-extract-plugin
export default {"share-icon-button":"styles_share-icon-button__Pbk7D","shareIconButton":"styles_share-icon-button__Pbk7D"};